<template>
<svg viewBox="0 0 24 24" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Landscape`]" width="1em" height="1em" v-bind="$attrs"><path d="M5.5 11.1619V5.5H11.1619C11.7141 5.5 12.1619 5.05228 12.1619 4.5 12.1619 3.94772 11.7141 3.5 11.1619 3.5H4.5C3.94772 3.5 3.5 3.94772 3.5 4.5V11.1619C3.5 11.7141 3.94772 12.1619 4.5 12.1619 5.05228 12.1619 5.5 11.7141 5.5 11.1619zM18.5 12.8381C18.5 12.2859 18.9477 11.8381 19.5 11.8381 20.0523 11.8381 20.5 12.2859 20.5 12.8381V19.5C20.5 20.0523 20.0523 20.5 19.5 20.5H12.8379C12.2856 20.5 11.8379 20.0523 11.8379 19.5 11.8379 18.9477 12.2856 18.5 12.8379 18.5H18.5V12.8381z"/></svg>
</template>
<script>

export default {
  name: 'IconLandscape',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
